import BaseDropdown from './dropdown';

class GranularitiesDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'granularities';
    // List item can be targeted by the item name, e.g. $('.dropdown-item.daily')
    this.identifierField = 'name';
    this.dropdownDiv = null;
    this.hasSearch = false;

    this.state = {
      opened: false,
      focusIndex: null,
      label: this.getLabel(this.props.items),
      granularities: this.props.items,
    };
  }

  componentDidUpdate(prevProps) {
    const currentItem = this.props.items.find(item => item.selected);
    if (currentItem.label !== this.state.label) {
      this.setState({ label: currentItem.label });
    }
  }

  select(index, event) {
    const updatedItems = this.props.items.map((option, idx) => {
      return { ...option, selected: idx === index };
    });

    const selectedOption = updatedItems.find(option => option.selected);
    const gaLabel = `${this.props.gaEvent.label} ${selectedOption.label}`;
    this.AnalyticService.trackEvent(this.props.gaEvent.category, 'Execute', gaLabel);

    this.setState({
      granularities: updatedItems,
      label: this.getLabel(updatedItems),
    });
    this.props.updateGranularities(updatedItems);
  }
}

export default GranularitiesDropdown;
